import React, {Component} from 'react'
import {Popup, Button, Modal} from 'semantic-ui-react'
import {buttonStyle} from './button-style'
import VpoPiFiles from '../new-vpo-page/vpo-pi-files.js'
import Utils from '../../modules/utils'

// adds PI files to every selected VPO (appended to their existing PI)
class BulkAddPi extends Component {

  constructor(props) {
    super(props)
    this.state = {
      open: false,
      piFiles: [],
      numVpos: 0,
      saving: false
    }
  }

  openModal = () => {
    if (this.props.numSelected == 0) {
      alert('Select at least 1 VPO')
    } else {
      this.setState({open: true, piFiles: [], numVpos: Object.keys(window.vpoIds).length})
    }
  }

  closeModal = () => {
    this.setState({open: false})
  }

  save = () => {
    let {piFiles} = this.state
    if (piFiles.length == 0) {
      alert('Upload at least 1 PI')
      return
    }

    let refs = Object.keys(window.vpoIds).filter(id => id != 'index').map(id => 'V' + id.padStart(4, '0'))
    if (refs.length > 50) {
      alert('Too many VPOs selected (' + refs.length + '). Add PI to at most 50 VPOs at a time.')
      return
    }
    if (!window.confirm('Add PI to these ' + refs.length + ' VPOs?\n\n' + refs.join(', '))) {
      return
    }

    this.setState({saving: true})
    Utils.post('bulk_add_vpo_pi', {vpoIds: window.vpoIds, piFiles}, (err, res) => {
      this.setState({saving: false})
      if (err) {
        alert('There was an error when trying to add PI.')
      } else {
        alert('PI added! Refresh the page to see it.')
        this.closeModal()
      }
    })
  }

  render() {
    let {open, piFiles, numVpos, saving} = this.state

    return (
      <React.Fragment>
        <Modal open={open} onClose={this.closeModal} size='small' closeIcon>
          <Modal.Header>Add PI to {numVpos} selected VPO{numVpos == 1 ? '' : 's'}</Modal.Header>
          <Modal.Content>
            <p style={{opacity: 0.6}}>Files are added to each VPO's existing PI.</p>
            <VpoPiFiles piFiles={piFiles} savedPiFiles={[]} setPiFiles={(piFiles) => this.setState({piFiles})}/>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={this.closeModal}>Cancel</Button>
            <Button primary loading={saving} disabled={saving} onClick={this.save}>Save</Button>
          </Modal.Actions>
        </Modal>
        <Popup content='Add PI' position='bottom left'
          trigger={
            <Button basic icon='file pdf outline' onClick={this.openModal} style={buttonStyle}/>
          }
        />
      </React.Fragment>
    )
  }
}

export default BulkAddPi
